import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./QuizzesScreen.module.css";
import { useCustomT } from "../hooks/useCustomT";
import { QuizStartScreenUrl, ChooseLanguageScreenUrl } from "../App";
import {
  ActiveQuizKeyName,
  getActiveQuizId,
} from "../helpers/dataHelpers";
import ArrowBlueUp from "../images/suva-blue_arrow.png";
import YellowCircle from "../images/suva-yellow_circle.png";
import ArrowRedDown from "../images/suva-red_arrow.png";
import MenuModule from "../images/menu-module.png";
import MenuActive from "../images/menu-module-current.png";
import {
  getActiveGameKeys,
  getKeyAnswersArrIndex,
} from "../helpers/gameHelpers";

const activeKeys = getActiveGameKeys();

const setActiveQuiz = (quizId) => {
  localStorage.setItem(ActiveQuizKeyName, quizId);
};

function QuizzesScreen({ quizzes = [], sounds }) {
  const [selectionIndex, setSelectionIndex] = useState(0);
  const customT = useCustomT();
  const navigate = useNavigate();
  const prev = () => {
    setSelectionIndex((index) => {
      if (index === 0) {
        return 0;
      } else {
        return index - 1;
      }
    });
    sounds.buttonSound();
  };

  const select = () => {
    setActiveQuiz(quizzes[selectionIndex]._id);
    navigate("/");
  };

  const next = () => {
    setSelectionIndex((index) => {
      if (index === quizzes.length - 1) {
        return quizzes.length - 1;
      } else {
        return index + 1;
      }
    });
    sounds.buttonSound();
  };

  const onKeyDown = (e) => {
    if (activeKeys.includes(e.key)) {
      const index = getKeyAnswersArrIndex(e.key);
      if (index === 0) {
        prev();
      }

      if (index === 1) {
        select();
      }

      if (index === 2) {
        next();
      }
    }
  };

  useEffect(() => {
    window.removeEventListener("keydown", onKeyDown);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [selectionIndex]);

  const sortedQuizzes = (quizzes) => quizzes.sort((a,b) => {
    if (customT(a.title) < customT(b.title)) {
      return -1;
    }
    if (customT(a.title) > customT(b.title)) {
      return 1;
    }
    return 0;
  })

  return (
    <>
      {getActiveQuizId() ? (
        <Navigate replace="true" to={QuizStartScreenUrl} />
      ) : (
        <div className={cn(styles.wrapper)}>
          <div className={styles.quizzesScreenWrapper}>
            <ul className={styles.quizzesList}>
              {sortedQuizzes(quizzes).map((quiz, index) => {
                {
                  return (
                    <React.Fragment key={quiz["_id"] ?? index}>
                      { quiz?.title && (
                        <Link
                          to={ChooseLanguageScreenUrl}
                          replace
                          onClick={() => {
                            setActiveQuiz(quiz["_id"]);
                          }}
                        >
                          <li className={styles.quizWrapper}>
                            <img
                              src={
                                index === selectionIndex
                                  ? MenuActive
                                  : MenuModule
                              }
                              alt="quiz"
                            />
                            <p
                              className={`${styles.quizText} ${
                                index === selectionIndex ? styles.checkmark : ""
                              }`}
                            >
                              {customT(quiz.title)}
                            </p>
                          </li>
                        </Link>
                      )}
                    </React.Fragment>
                  );
                }
              })}
            </ul>
          </div>
          <div>
            <div className={styles.navigation}>
              <div onClick={prev}>
                <img src={ArrowBlueUp} alt="" />
              </div>
              <div style={{ marginTop: "36px" }} onClick={select}>
                <img src={YellowCircle} alt="" />
              </div>
              <div style={{ marginTop: "36px" }} onClick={next}>
                <img src={ArrowRedDown} alt="" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuizzesScreen;
